import axios from 'axios'
import { APIUrls, Headers } from 'src/app/helpers/connection/API'
import { APIResponseModel } from "src/app/helpers/connection/models"
import { OptionsModel } from 'src/app/helpers/components/forms/Inputs'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { tr } from '@faker-js/faker'

export async function getLibraryData(params: any) {
  try {
    const { data: resp } = await axios.get(`${APIUrls.Library.lib}/${params.code}/list?pageNumber=${params.page}&noOfPageRec=10`);
    if (resp) {
      return resp
    }
    return resp
  } catch (error: any) {
    console.error('Error fetching library data:', {
      code: params.code,
      page: params.page,
      error: error?.response?.data || error.message
    })
    throw error
  }
}

export async function addLibrary(data: any) {
  const { data: resp } = await axios.post(`${APIUrls.Library.lib}/${data?.code}/records`, data);
  if (resp.data) {
    return resp.data
  }
  return resp
}


export async function updateUserPermission(data: any) {
  try {
    const { data: resp } = await axios.put(`${APIUrls.Library.lib}/${data?.code}/permission-groups`, data);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function deleteUserPermission(data: any) {
  console.log(data);

  try {
    const { data: resp } = await axios.delete(`${APIUrls.Library.lib}/${data?.userCode}/permission-groups`, data);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getLibraryList() {
  const { data: resp } = await axios.get(`${APIUrls.Library.lib}`);
  if (resp.data) {
    return resp.data
  }
  return resp
}


export async function getRecordHistories(libraryCode: string, recSetId: string) {
  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/histories`
  )

  return resp
}



export async function postAdminUser(newUser: any) {
  const { data: resp } = await axios.post(`${APIUrls.Library.lib}`, newUser);
  if (resp.data) {
    return resp.data
  }
  return resp
}

export async function putAdminUser(code: any, updatedUser: any) {
  try {
    const { data: resp } = await axios.put(`${APIUrls.Library.lib}/${code}`, updatedUser);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function deleteAdminUser(code: any) {
  try {
    const { data: resp } = await axios.delete(`${APIUrls.Library.lib}/${code}`);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getAdminDepartmentList() {
  const { data: resp } = await axios.get(`${APIUrls.Services.Department}`);
  if (resp.data) {
    return resp.data
  }

  return resp
}

export async function getAdminPositionList() {
  const { data: resp } = await axios.get(`${APIUrls.Services.Position}`);
  if (resp.data) {
    return resp.data
  }
  return resp
}



export async function getAdminPermissionList() {
  const { data: resp } = await axios.get(`${APIUrls.Services.Access}`);
  if (resp.data) {
    return resp.data
  }
  return resp
}


export async function listSearch(libraryCode: string, params: any) {
  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/list-search`,
    {
      params: params
    }
  );
  return resp;
}


export async function listSimpleSearch(params: { rawCondition?: string, pageNumber?: number }) {
  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/list-simple-search`,
    {
      params: params
    }
  );
  return resp;
}

export async function getProfileDesign(status?: string) {
  const { data: resp } = await axios.get(`${APIUrls.Record.RecProfiles}`, {
    params: {
      status: status
    }
  });
  if (resp.data) {
    return resp.data;
  }
  return resp;
}

export async function getProfileDetails(id: any) {
  const { data: resp } = await axios.get(`${APIUrls.Record.RecProfiles}/${id}`, {
  });
  return resp.data || resp;
}



export async function getLibraryRecordBySetId(libraryCode: any, recSetId: any) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}`
    )

    if (resp.data) {
      return resp.data
    }
    return resp
  } catch (error: any) {
    console.error('Error fetching library record:', {
      libraryCode,
      recSetId,
      error: error?.response?.data || error.message,
      status: error?.response?.status
    })
    throw error
  }
}


export async function getLibraryRecordList(libraryCode: string) {
  const { data } = await axios.get(`${APIUrls.Library.lib}/${libraryCode}/list`);

  return data;
}




export async function deleteLibraryRecordBySetId(libraryCode: any, recSetId: any) {
  try {
    const { data: resp } = await axios.delete(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}`
    )
    toast.success('Deleted successfully');
    if (resp.data) {
      return resp.data
    }
    return resp
  }
  catch (error: any) {
    toast.error(`Library Not Deleted Successfully`);
  }
}


export async function editLibraryRecordBySetId(libraryCode: any, recSetId: any, updatedData: any) {
  try {
    const { data: resp } = await axios.put(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}`,
      updatedData
    )
    toast.success('Updated successfully');

    if (resp.data) {
      return resp.data
    }
    return resp
  }
  catch (error: any) {
    toast.error(`Library Not Updated Successfully`);
  }
}


export async function exportLibraryListSearch(libraryCode: any, params?: any) {
  const response = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/list-search/export`,
    {
      params,
      responseType: 'blob'
    }
  )

  if (response.data) {
    return response.data;
  }
  return response;
}



export async function fetchLibraryDocsBySetId(libraryCode: string, recSetId: string) {

  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/list`
  );

  if (resp.data) {
    return resp.data;
  }
  return resp;
}


export async function updatedFetchLibraryDocsBySetId(libraryCode: string, recSetId: string, docSetId: string) {

  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}`
  );

  if (resp.data) {
    return resp.data;
  }
  return resp;
}




export async function addLibraryDocBySetId(libraryCode: string, recSetId: string, docs: Array<{ file: string; fileName: string; docType: string }>) {
  try {
    const formData = new FormData();


    docs.forEach((doc, index) => {

      const byteCharacters = atob(doc.file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      formData.append(`docs[${index}].file`, blob, doc.fileName);
      formData.append(`docs[${index}].fileName`, doc.fileName);
      formData.append(`docs[${index}].docType`, doc.docType);
    });

    const { data: resp } = await axios.post(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success('Document(s) added successfully');
    return resp?.data || resp;
  } catch (error: any) {
    toast.error('Failed to add document(s)');
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
}


export async function updateLibraryDocByDocId(
  libraryCode: string,
  recSetId: string,
  docId: string,
  file: string,
  fileName: string,
  docType: string
) {
  try {
    const formData = new FormData();

    // convert base64 to blob
    const byteCharacters = atob(file);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    formData.append("file", blob, fileName);
    formData.append("fileName", fileName);
    formData.append("docType", docType);

    const { data: resp } = await axios.put(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Document updated successfully");
    return resp?.data || resp;
  } catch (error: any) {
    toast.error("Failed to update document");
    console.error("API Error:", error.response?.data || error);
    throw error;
  }
}



export async function fetchLibraryDocUrlById(libraryCode: string, recSetId: string, docSetId: string, docId: string) {
  const { data: resp } = await axios.get(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}/${docId}/url`
  );

  if (resp.data) {
    return resp.data;
  }

  return resp;
}


export async function deleteLibraryDocById(
  libraryCode: string,
  recSetId: string,
  docSetId: string
) {
  try {
    const { data: resp } = await axios.delete(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}`
    );

    toast.success("Document deleted successfully"); 
    return resp;
  } catch (error: any) {
    console.error("Error deleting library doc:", error);
    toast.error(
      error?.response?.data?.message || "Failed to delete document"
    ); 
    throw error;
  }
}



export async function checkoutLibraryDoc(
  libraryCode: string,
  recSetId: string,
  docSetId: string,
  payload: { checkoutReason: string; targetCheckinDate: string }
) {
  const { data: resp } = await axios.post(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}/checkout`,
    payload
  );

  if (resp?.data) {
    return resp.data;
  }

  return resp;
}



export async function checkinLibraryDoc(
  libraryCode: string,
  recSetId: string,
  docSetId: string
) {
  const { data: resp } = await axios.post(
    `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}/checkin`
  );

  if (resp?.data) {
    return resp.data;
  }

  return resp;
}




export async function updateLibraryDocProperties(
  libraryCode: string,
  recSetId: string,
  docSetId: string,
  properties: Record<string, any>
) {
  try {
    const { data: resp } = await axios.put(
      `${APIUrls.Library.lib}/${libraryCode}/records/${recSetId}/docs/${docSetId}/properties`,
      properties
    );

    if (resp?.data) {
      return resp.data;
    }

    return resp;
  } catch (error: any) {
    console.error("Failed to update document properties:", error);
    throw error;
  }
}


// Get current user permissions for a library
export async function getCurrentUserPermission(recordProfileCode: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.Library.LibraryAccessPermission}/GetCurrentUserPermission/${recordProfileCode}`
    );

    if (resp?.data) {
      return resp.data;
    }

    return resp;
  } catch (error: any) {
    console.error("Failed to fetch user permissions:", error);
    throw error;
  }
}